import { Injectable } from "@angular/core";

@Injectable()
export class HotspotDotColorService {
  public getDotColor(
    hotspotCount: number,
    hotspotsSum: number,
    hotspotsLength: number,
  ) {
    const avg = hotspotsSum / hotspotsLength;
    const avgRangePercent = 20;
    const avgCeil = avg + (avg * avgRangePercent) / 100;
    const avgFloor = avg - (avg * avgRangePercent) / 100;

    if (hotspotCount > avgCeil) {
      return "bkg-color--danger";
    }
    if (hotspotCount <= avgCeil && hotspotCount >= avgFloor) {
      return "bkg-color--orange-400";
    }
    if (hotspotCount < avgFloor) {
      return "bkg-color--blue-400";
    }
  }
}
